<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="header-title">{{ headerName }} </span>

    <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal row">
    <div class="bootstrap-dialog-message">Are you sure you want to delete this?</div>
  </div>
  <div class="modal-footer box-footer">
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Yes</button>
    <button type="button" class="btn btn-light cancel-btn modelBtn" (click)="onClose()">
      Close
    </button>
  </div>
</div>
